module.exports = __webpack_public_path__ + "static/img/171019.65200fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/171019.png
// module id = miNc
// module chunks = 0